class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
    // this.thumbnailSlider = null;
    this.maxPageWidth = parseFloat(getComputedStyle(this.closest('.shopify-section')).getPropertyValue('max-width'));
    this.resizeObserver = null;
  }

  connectedCallback() {
    this.slider = this.initMainSlider();

    if (this.querySelector('[data-ref="thumbnail-slider"]')) {
      this.thumbnailSlider = this.initThumbnailSlider();
    }

    if (this.thumbnailSlider) {
      this.slider.sync(this.thumbnailSlider);
    }

    this.slider.mount();

    if (this.thumbnailSlider) {
      this.thumbnailSlider.mount();
    }

    if (!this.thumbnailSlider) {
      this.slider.on('mounted', () => {
        this.updateSize();
        if (this.classList.contains('slider-component--overflow-opacity')) {
          this.#initOverflowOpacity();
        }
      });

    this.slider.on('moved', () => {
      if (this.classList.contains('slider-component--overflow-opacity')) {
        this.#updateOverflowOpacity();
      }
    });

    this.slider.on('move', () => {
      if (this.classList.contains('slider-component--overflow-opacity')) {
        this.#updateOverflowOpacity();
      }
    });

    this.slider.on('drag', () => {
      if (this.classList.contains('slider-component--overflow-opacity')) {
        this.#updateOverflowOpacity();
      }
    });

    this.slider.on('dragging', () => {
      if (this.classList.contains('slider-component--overflow-opacity')) {
        this.#updateOverflowOpacity();
      }
    });

      this.slider.on('resized', () => {
        if (this.classList.contains('slider-component--overflow-opacity')) {
          this.#updateOverflowOpacity();
        }
      });

      this.resizeObserver = new ResizeObserver(() => {
        this.updateSize();
        if (this.classList.contains('slider-component--overflow-opacity')) {
          this.#updateOverflowOpacity();
        }
      });
      this.resizeObserver.observe(document.documentElement);
    }
  }

  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  #initOverflowOpacity() {
    this.#updateOverflowOpacity();
  }

  #updateOverflowOpacity() {
    const pageWidthContainer = this.closest('.page-width') || this.closest('.shopify-section');
    if (!pageWidthContainer) return;

    const slides = this.querySelectorAll('.splide__slide');
    const containerRect = pageWidthContainer.getBoundingClientRect();

    slides.forEach((slide) => {
      const slideRect = slide.getBoundingClientRect();
      const isFullyInPageWidth = slideRect.left >= containerRect.left && slideRect.right <= containerRect.right;
      const isPartiallyVisible = (slideRect.left < containerRect.right && slideRect.right > containerRect.left) && !isFullyInPageWidth;

      if (isFullyInPageWidth) {
        slide.classList.remove('is-partially-visible');
      } else if (isPartiallyVisible) {
        slide.classList.add('is-partially-visible');
      } else {
        slide.classList.remove('is-partially-visible');
      }
    });
  }

  initMainSlider() {
    const perPageDesktop = this.getAttribute('data-per-page-desktop');
    let perPageMobile = this.getAttribute('data-per-page-mobile');
    const gap = this.getAttribute('data-gap') + 'px';
    const showArrows = this.getAttribute('data-show-arrows') === 'true';
    const showArrowsMobile = this.getAttribute('data-show-arrows-mobile') === 'true';
    const showPagination = this.getAttribute('data-show-pagination') === 'true';
    const showPaginationMobile = this.getAttribute('data-show-pagination-mobile') === 'true';
    const autoplay = this.getAttribute('data-autoplay') === 'true';
    const autoplaySpeed = this.getAttribute('data-autoplay-speed') + '000';
    const autoWidth = this.getAttribute('data-auto-width') === 'true';
    const rewind = this.getAttribute('data-rewind') === 'true';
    const continuousNavigation = this.getAttribute('data-infinite-loop') === 'true';

    if (perPageMobile === '1.8') perPageMobile = 1;
    const enableMobilePeek =
      perPageMobile === '1' &&
      this.classList.contains('slider-component--show-overflow') &&
      this.classList.contains('slider-component--infinite-loop');

    const splideOptions = {
      perPage: perPageMobile,
      perMove: 1,
      rewind: rewind,
      gap: gap,
      drag: true,
      snap: true,
      arrows: showArrows,
      arrowsMobile: showArrowsMobile,
      pagination: showPaginationMobile,
      autoplay: autoplay,
      interval: autoplaySpeed,
      autoWidth: autoWidth,
      autoHeight: true,
      lazyLoad: false,
      flickMaxPages: 1,
      flickPower: 400,
      mediaQuery: 'min',
      breakpoints: {
        750: {
          perPage: perPageDesktop,
          pagination: showPagination,
          arrows: showArrows,
        },
      },
    };

    if (enableMobilePeek) {
      splideOptions.padding = { left: '12%', right: '12%' };
      if (splideOptions.breakpoints && splideOptions.breakpoints[750]) {
        splideOptions.breakpoints[750].padding = 0;
      }
    }

    if (continuousNavigation) {
      splideOptions.type = 'loop';
      splideOptions.rewind = false;
      if (splideOptions.breakpoints && splideOptions.breakpoints[750]) {
        splideOptions.breakpoints[750].type = 'loop';
        splideOptions.breakpoints[750].rewind = false;
      }
    } else {
      splideOptions.type = 'slide';
    }

    return new Splide(this.querySelector('[data-ref="main-slider"]'), splideOptions);
  }

  initThumbnailSlider() {
    const showArrows = this.getAttribute('data-show-arrows-thumbnails') === 'true';
    const thumbnailsDirectionDesktop = this.getAttribute('data-thumbnails-direction-desktop');
    const thumbnailsPerPageDesktop = Number.parseInt(this.getAttribute('data-thumbnails-per-page-desktop') ?? '', 10);
    const thumbnailsSizeDesktop = Number.parseInt(this.getAttribute('data-thumbnails-size-desktop') ?? '', 10);
    const thumbnailsGapDesktop = Number.parseInt(this.getAttribute('data-thumbnails-gap-desktop') ?? '', 10);

    const splideOptions = {
      fixedWidth: 84,
      fixedHeight: 84,
      gap: 40,
      rewind: true,
      pagination: false,
      isNavigation: true,
      arrows: showArrows,
      breakpoints: {
        750: {
          fixedWidth: 64,
          fixedHeight: 64,
          gap: 20,
        },
      },
    };

    if (thumbnailsDirectionDesktop === 'vertical') {
      splideOptions.mediaQuery = 'min';
      splideOptions.breakpoints = {
        750: {
          direction: 'ttb',
          fixedWidth: thumbnailsSizeDesktop || 48,
          fixedHeight: thumbnailsSizeDesktop || 48,
          gap: thumbnailsGapDesktop || 8,
          height: `${(thumbnailsSizeDesktop || 48) * (thumbnailsPerPageDesktop || 3) + (thumbnailsGapDesktop || 8) * ((thumbnailsPerPageDesktop || 3) - 1)}px`,
          perPage: thumbnailsPerPageDesktop || 3,
          arrows: showArrows,
        },
      };
    }

    return new Splide(this.querySelector('[data-ref="thumbnail-slider"]'), splideOptions);
  }

  updateSize() {
    this.pageWidth = document.documentElement.clientWidth;
    this.sectionPadding = parseFloat(getComputedStyle(this.closest('.shopify-section')).getPropertyValue('padding-right'));

    var padding = this.sectionPadding;
    if (this.pageWidth > this.maxPageWidth) {
      padding = (this.pageWidth - this.maxPageWidth) / 2 + this.sectionPadding;
    }

    this.style.width = `calc(100% + ${2 * padding}px)`;
    this.style.marginLeft = `-${padding}px`;
    this.style.marginRight = `-${padding}px`;

    let perPageMobile = this.getAttribute('data-per-page-mobile');
    if (perPageMobile === '1.8') perPageMobile = 1;    
    const enableMobilePeek =
      perPageMobile === '1' &&
      this.classList.contains('slider-component--show-overflow') &&
      this.classList.contains('slider-component--infinite-loop');
    
    let trackPaddingInline = padding;
    let arrowPositionInline = padding + 10;    

    if (enableMobilePeek) {
      trackPaddingInline = padding + 20;
      arrowPositionInline = padding - 10;
    }

    if (this.querySelector('.splide__track')) {
      this.querySelector('.splide__track').style.paddingRight = `${trackPaddingInline}px`;
      this.querySelector('.splide__track').style.paddingLeft = `${trackPaddingInline}px`;
    }

    if (this.querySelector('.splide__arrow--prev') && this.querySelector('.splide__arrow--next')) {
      this.querySelector('.splide__arrow--prev').style.left = `${arrowPositionInline}px`;
      this.querySelector('.splide__arrow--next').style.right = `${arrowPositionInline}px`;
    }
  }

  remove(index) {
    this.slider.remove(index);
  }
}

if (!customElements.get('slider-component')) {
  customElements.define('slider-component', SliderComponent);
}
